import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'secondsToMinutes',
})
export class SecondsToMinutesPipe implements PipeTransform {
    transform(seconds: number, format: string = ''): string {
        const minutes = Math.floor(seconds / 60);

        if (format === 'ms') {
            if (minutes < 2) {
                return `${seconds}s`;
            } else {
                return `${minutes}m ${seconds - minutes * 60}s`;
            }
        } else if (format === 'mmss') {
            if (minutes < 2) {
                const ss = this.getSS(seconds);
                return `00:${ss}`;
            } else {
                const ss = this.getSS(seconds - minutes * 60);
                return `${minutes}:${ss}`;
            }
        } else {
            if (minutes < 2) {
                return `${seconds} ${this.getSecondString(seconds)}`;
            } else {
                return `${minutes} ${this.getMinuteString(minutes)}`;
            }
        }
    }

    private getSecondString(seconds: number): string {
        if (seconds === 1) {
            return 'sekunda';
        } else if (seconds >= 2 && seconds <= 4) {
            return 'sekundy';
        } else {
            return 'sekund';
        }
    }

    private getMinuteString(minutes: number): string {
        if (minutes === 1) {
            return 'minuta';
        } else if (minutes >= 2 && minutes <= 4) {
            return 'minuty';
        } else {
            return 'minut';
        }
    }

    private getSS(seconds: number): string {
        return seconds < 10 ? `0${seconds}` : String(seconds);
    }
}
